export default __webpack_public_path__ + "static/media/receiving_livestream.73fba0fe.wav";